/* ==========================================================================
   DIME Refresh JS (2026)
   - tiny, performance-safe enhancements
   - no heavy libraries
   ========================================================================== */

/* Mobile Sticky Add-to-Cart (PDP)
   - Appears after user scrolls past the primary ATC area
   - Mirrors the existing ATC button by triggering a click
*/
(function(){
  const ready = (fn) => (document.readyState !== 'loading') ? fn() : document.addEventListener('DOMContentLoaded', fn);

  ready(() => {
    const isPDP = document.body.classList.contains('template-product');
    if (!isPDP) return;

    const primaryBtn = document.querySelector('form[action^="/cart/add"] button[type="submit"], product-form button[type="submit"]');
    if (!primaryBtn) return;

    const bar = document.createElement('div');
    bar.className = 'dm-sticky-atc';
    bar.innerHTML = `
      <div class="dm-sticky-atc__inner">
        <div class="dm-sticky-atc__left">
          <div class="dm-sticky-atc__title"></div>
          <div class="dm-sticky-atc__price"></div>
        </div>
        <button class="dm-sticky-atc__btn" type="button">Add to cart</button>
      </div>
    `;
    document.body.appendChild(bar);

    const titleEl = bar.querySelector('.dm-sticky-atc__title');
    const priceEl = bar.querySelector('.dm-sticky-atc__price');
    const btnEl = bar.querySelector('.dm-sticky-atc__btn');

    const titleSource = document.querySelector('.product__title h1, h1.product__title, .product__title');
    if (titleSource) titleEl.textContent = titleSource.textContent.trim();

    const updatePrice = () => {
      const priceSource = document.querySelector('.price .price-item--sale, .price .price-item--regular, .product__info-wrapper .price');
      if (priceSource) priceEl.textContent = priceSource.textContent.replace(/\s+/g,' ').trim();
    };
    updatePrice();

    btnEl.addEventListener('click', () => {
      // If button disabled because variant not selected, scroll to form
      if (primaryBtn.hasAttribute('disabled')) {
        primaryBtn.scrollIntoView({behavior:'smooth', block:'center'});
        primaryBtn.focus({preventScroll:true});
        return;
      }
      primaryBtn.click();
    });

    const sentinel = document.createElement('div');
    sentinel.style.cssText = 'position:relative;width:100%;height:1px;';
    // Place sentinel just above the primary button if possible
    const form = primaryBtn.closest('form') || primaryBtn.closest('product-form') || primaryBtn.parentElement;
    if (form && form.parentElement) form.parentElement.insertBefore(sentinel, form);

    const show = () => bar.classList.add('is-visible');
    const hide = () => bar.classList.remove('is-visible');

    // Only show on small screens
    const mq = window.matchMedia('(max-width: 749px)');

    const io = new IntersectionObserver((entries)=>{
      if (!mq.matches) { hide(); return; }
      const entry = entries[0];
      if (!entry) return;
      // If sentinel is visible, we are near ATC -> hide bar
      if (entry.isIntersecting) hide();
      else show();
    }, {threshold: 0});

    io.observe(sentinel);

    // Watch for variant changes that update price
    const mo = new MutationObserver(()=>updatePrice());
    const priceContainer = document.querySelector('.product__info-wrapper .price') || document.querySelector('.price');
    if (priceContainer) mo.observe(priceContainer, {childList:true, subtree:true, characterData:true});
  });
})();
